export default __webpack_public_path__ + "media/zurb/img/legacy/strike/instructions-7-f842c8390e4e745509cd650096048261.jpg";